// extracted by mini-css-extract-plugin
export var divider = "_jl-0";
export var systemMessage = "_jl-1";
export var systemMessageWrapper = "_jl-2";